/* FrameDex — Display Finder
   Lists all Pokémon (1–1025) grouped by region, with search + filters (region,
   availability). Click a Pokémon → matching displays (mapped via product metafield
   custom.pokemon_dex) or a Wunschmotiv CTA. Data: pokemon-dex.json + inline JSON. */
(function () {
  var root = document.querySelector('[data-display-finder]');
  if (!root) return;

  var lang = (root.dataset.locale || 'de').slice(0, 2) === 'en' ? 'en' : 'de';
  var CELL = parseInt(root.dataset.spriteCell, 10) || 48;
  var COLS = parseInt(root.dataset.spriteCols, 10) || 40;
  var SHOW_SPRITES = root.dataset.showSprites === 'true';
  var WUNSCH = root.dataset.wunschmotiv || '/pages/wunschmotiv';

  var i18n = parseJSON(root.querySelector('[data-df-i18n]')) || {};
  var rawDisplays = parseJSON(root.querySelector('[data-df-displays]')) || [];

  var REGIONS = {
    1: { de: 'Kanto', en: 'Kanto' }, 2: { de: 'Johto', en: 'Johto' }, 3: { de: 'Hoenn', en: 'Hoenn' },
    4: { de: 'Sinnoh', en: 'Sinnoh' }, 5: { de: 'Einall', en: 'Unova' }, 6: { de: 'Kalos', en: 'Kalos' },
    7: { de: 'Alola', en: 'Alola' }, 8: { de: 'Galar', en: 'Galar' }, 9: { de: 'Paldea', en: 'Paldea' }
  };

  // dex -> [display]
  var dexMap = {};
  rawDisplays.forEach(function (d) {
    var list = Array.isArray(d.dex) ? d.dex : [d.dex];
    list.forEach(function (n) {
      n = parseInt(n, 10); if (!n) return;
      (dexMap[n] = dexMap[n] || []).push(d);
    });
  });

  var els = {
    results: root.querySelector('[data-df-results]'),
    status: root.querySelector('[data-df-status]'),
    count: root.querySelector('[data-df-count]'),
    regions: root.querySelector('[data-df-regions]'),
    search: root.querySelector('[data-df-search]'),
    modal: root.querySelector('[data-df-modal]'),
    modalSprite: root.querySelector('[data-df-modal-sprite]'),
    modalDex: root.querySelector('[data-df-modal-dex]'),
    modalName: root.querySelector('[data-df-modal-name]'),
    modalBody: root.querySelector('[data-df-modal-body]')
  };

  var state = { region: 'all', avail: 'all', query: '' };
  var cells = [];
  var lastFocus = null;

  fetch(root.dataset.dexUrl)
    .then(function (r) { return r.json(); })
    .then(build)
    .catch(function () { if (els.status) els.status.textContent = i18n.empty || 'Fehler beim Laden.'; });

  function build(pokemon) {
    for (var g = 1; g <= 9; g++) {
      var b = document.createElement('button');
      b.type = 'button'; b.className = 'df-pill'; b.dataset.dfRegion = String(g);
      b.textContent = REGIONS[g][lang];
      els.regions.appendChild(b);
    }

    var frag = document.createDocumentFragment();
    var byGen = {};
    pokemon.forEach(function (p) { (byGen[p.gen] = byGen[p.gen] || []).push(p); });

    for (var gen = 1; gen <= 9; gen++) {
      if (!byGen[gen]) continue;
      var sec = document.createElement('section');
      sec.className = 'df-region'; sec.dataset.region = String(gen);
      var h = document.createElement('h2');
      h.className = 'df-region__title'; h.textContent = REGIONS[gen][lang];
      sec.appendChild(h);
      var grid = document.createElement('div'); grid.className = 'df-grid';

      byGen[gen].forEach(function (p) {
        var offered = !!dexMap[p.dex];
        var has = offered && dexMap[p.dex].some(function (d) { return d.available; });
        var name = p[lang] || p.de;
        var cell = document.createElement('button');
        cell.type = 'button';
        cell.className = 'df-cell' + (offered ? ' df-cell--has' : '');
        cell.dataset.dex = String(p.dex);
        var html = '';
        if (SHOW_SPRITES) html += '<span class="df-cell__sprite" style="background-position:' + spritePos(p.dex, CELL) + '"></span>';
        html += '<span class="df-cell__dex">#' + pad(p.dex) + '</span>';
        html += '<span class="df-cell__name">' + esc(name) + '</span>';
        if (has) html += '<span class="df-cell__badge" title="' + (i18n.badge || '') + '"></span>';
        cell.innerHTML = html;
        grid.appendChild(cell);
        cells.push({ el: cell, dex: p.dex, name: (p.de + ' ' + p.en).toLowerCase(), gen: gen, has: has });
      });

      sec.appendChild(grid);
      frag.appendChild(sec);
    }

    els.results.innerHTML = '';
    els.results.appendChild(frag);
    applyFilters();
    wire();
  }

  function wire() {
    els.regions.addEventListener('click', function (e) {
      var b = e.target.closest('[data-df-region]'); if (!b) return;
      state.region = b.dataset.dfRegion;
      setActive(els.regions, b, '.df-pill');
      applyFilters();
    });
    root.querySelectorAll('[data-df-avail]').forEach(function (b) {
      b.addEventListener('click', function () {
        state.avail = b.dataset.dfAvail;
        setActive(b.parentNode, b, '.df-toggle');
        applyFilters();
      });
    });
    var t;
    els.search.addEventListener('input', function () {
      clearTimeout(t);
      t = setTimeout(function () { state.query = els.search.value.trim().toLowerCase(); applyFilters(); }, 120);
    });
    els.results.addEventListener('click', function (e) {
      var cell = e.target.closest('.df-cell'); if (!cell) return;
      openModal(parseInt(cell.dataset.dex, 10));
    });
    root.querySelectorAll('[data-df-close]').forEach(function (b) { b.addEventListener('click', closeModal); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !els.modal.hidden) closeModal(); });
  }

  function applyFilters() {
    var visible = 0, avail = 0, q = state.query;
    cells.forEach(function (c) {
      var ok = true;
      if (state.region !== 'all' && String(c.gen) !== state.region) ok = false;
      if (ok && state.avail === 'available' && !c.has) ok = false;
      if (ok && q) ok = c.name.indexOf(q) !== -1 || String(c.dex).indexOf(q.replace('#', '')) !== -1;
      c.el.classList.toggle('is-hidden', !ok);
      if (ok) { visible++; if (c.has) avail++; }
    });
    root.querySelectorAll('.df-region').forEach(function (sec) {
      sec.classList.toggle('is-hidden', !sec.querySelector('.df-cell:not(.is-hidden)'));
    });
    els.count.textContent = visible + ' ' + (i18n.pokemonWord || 'Pokémon') + ' · ' + avail + ' ' + (i18n.withDisplay || 'mit Display');
  }

  function openModal(dex) {
    var displays = dexMap[dex] || [];
    var nameText = '#' + dex;
    for (var i = 0; i < cells.length; i++) {
      if (cells[i].dex === dex) { nameText = cells[i].el.querySelector('.df-cell__name').textContent; break; }
    }
    els.modalDex.textContent = '#' + pad(dex);
    els.modalName.textContent = nameText;
    els.modalSprite.style.display = SHOW_SPRITES ? '' : 'none';
    if (SHOW_SPRITES) els.modalSprite.style.backgroundPosition = spritePos(dex, 64);

    if (displays.length) {
      var h = '<p class="label df-displays__title">' + (i18n.displaysTitle || '') + '</p><div class="df-displays">';
      displays.forEach(function (d) {
        h += '<a class="df-display" href="' + esc(d.url) + '">'
          + '<span class="df-display__img">' + (d.img ? '<img src="' + esc(d.img) + '" alt="" loading="lazy">' : '') + '</span>'
          + '<span class="df-display__info"><span class="df-display__title">' + esc(d.title) + '</span>'
          + '<span class="df-display__price">' + (d.available ? esc(d.price) : (i18n.soldout || '')) + '</span></span>'
          + '<span class="df-display__cta btn btn--secondary">' + (i18n.view || '') + '</span>'
          + '</a>';
      });
      els.modalBody.innerHTML = h + '</div>';
    } else {
      els.modalBody.innerHTML = '<div class="df-empty"><p class="df-empty__title">' + (i18n.noTitle || '') + '</p>'
        + '<p class="text-muted">' + (i18n.noText || '') + '</p>'
        + '<a class="btn btn--primary df-empty__cta" href="' + esc(WUNSCH) + '">' + (i18n.noCta || '') + '</a></div>';
    }

    lastFocus = document.activeElement;
    els.modal.hidden = false;
    document.body.classList.add('drawer-open');
    var closeBtn = els.modal.querySelector('.df-modal__close');
    if (closeBtn) closeBtn.focus();
  }

  function closeModal() {
    els.modal.hidden = true;
    document.body.classList.remove('drawer-open');
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  function spritePos(dex, cell) {
    var i = dex - 1, col = i % COLS, row = Math.floor(i / COLS);
    return (-(col * cell)) + 'px ' + (-(row * cell)) + 'px';
  }
  function pad(n) { return n < 10 ? '00' + n : n < 100 ? '0' + n : '' + n; }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (m) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[m];
    });
  }
  function setActive(container, btn, sel) {
    container.querySelectorAll(sel).forEach(function (x) { x.classList.remove('is-active'); });
    btn.classList.add('is-active');
  }
  function parseJSON(el) { try { return el ? JSON.parse(el.textContent) : null; } catch (e) { return null; } }
})();
